import { render, staticRenderFns } from "./radiocontrol.vue?vue&type=template&id=08c8d6f8&scoped=true&"
import script from "./radiocontrol.vue?vue&type=script&lang=js&"
export * from "./radiocontrol.vue?vue&type=script&lang=js&"
import style0 from "./radiocontrol.vue?vue&type=style&index=0&id=08c8d6f8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c8d6f8",
  null
  
)

export default component.exports